module.exports = __webpack_public_path__ + "Server-Unhealthy-TentaclePassive.e2fb6fc1aa329b8cc18ac932ebfe027f.hashedasset.svg";